import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'


import {
  tryToFetchMyAccountInfo,
  tryToCreateUserStripeCheckoutSession
} from '../../actions/actions.export'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');


class UserSettingsUpgradeToProForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      // idempotency_key: shortid.generate(),
      // lastFail: props.user.failedToUpgradeToPro,
      policyCheck: false,
      pricing: Cookies.get("pricing_preference") || "monthly"
    }

    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  // componentWillReceiveProps(newProps){
  //   if(newProps.user.failedToUpgradeToPro !== this.state.lastFail){
  //     this.setState({
  //       lastFail: newProps.user.failedToUpgradeToPro,
  //       idempotency_key: shortid.generate()
  //     })
  //   }
  // }

  // componentDidMount(){
  //   this.setState({
  //     idempotency_key: shortid.generate()
  //   })
  // }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  // handleSubmit(stripe_token){
  //   this.props.dispatch(tryToUpgradeToPro({
  //     stripe_token: stripe_token,
  //     idempotency_key: this.state.idempotency_key,
  //     pricing: this.state.pricing
  //   }))
  // }

  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    return (
      <div className="stripe-cc-form">
        <p>
          Upgrade to Pro to unlock the full power of Pattycake's pattern editors. Draw more lines in more ways, export high res images, and save unlimited private patterns. After the trial period, your monthly billing cycle will automatically begin. No long term commitments, cancel anytime.
        </p>
        <div className="list-left">
          <Link to="/feature-table" className="button-link">
            <Button
              display={<span>Compare plans in detail&nbsp; <i className="fal fa-angle-double-right"/></span>}
              
              size="medium"
            />
          </Link>
        </div>
        <hr/>

        <div className="row">
          <div className="col-md-5">
            <div className="div-info-text-large-pad no-margin-top no-margin-bottom">
              <h5>Before checking out...</h5>
              <p className="text-thin-line-height">
                <small>Pattycake Pro is a subscription, paid for in monthly or yearly increments, that unlocks additional features of the Pattycake platform. Your Pattycake Pro subscription can be canceled at anytime via your account's billing settings.</small><br/><br/>
                <small>Upon checkout, your 30 day trial of Pattycake Pro will begin. This trial automatically converts into a paid subscription after 30 days if not canceled. If you are re-subscribing, you may have already used your trial period.</small><br/><br/>
                <small>Pattycake Pro is subject to Pattycake's <Link to="/tos">Terms of Service</Link> agreement.</small><br/><br/>
              </p>
              <div className="agree-wrapper">
                <div className="agree-check">
                  <Checkbox value={this.state.policyCheck} onToggle={() => { this.setState({policyCheck: !this.state.policyCheck}) }}/>
                </div>
                <div className="agree-text">
                  I understand and accept.
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7">
            <div className="box">
              <p>
                Pattycake Pro comes with a one-time 30 day free trial. Once the trial is complete, you'll pay:
              </p>
              <div className="flex-split">
                <p className="">
                  <strong>Per {this.state.pricing  === "monthly" ? "month" : "year"}:</strong>
                </p>
                <div>
                  <h3 ><strong>${this.state.pricing === "monthly" ? pf_config.plans.pro.price : pf_config.plans.pro.price_yearly}</strong></h3>
                </div>
              </div>

              <div className="flex-split medium-margin-bottom">
                <p className="">
                  Pay yearly and get two months free:<br/>
                  <small className="text-muted">Compared to 12 months at ${pf_config.plans.pro.price} / month</small>
                </p>
                <p className="text-large-switch">
                  <Checkbox large={true} switch={true} value={this.state.pricing === "yearly"} onToggle={() => { this.setState({pricing: this.state.pricing === "monthly" ? "yearly" : "monthly"}) }}/>
                </p>
              </div>
              <p className="text-thin-line-height">
                <small>
                  Pattycake uses <a href="https://stripe.com" rel="noopener noreferrer" target="_blank">Stripe</a> as our payment provider. Once checkout is completed, you'll be redirected back here and your Pattycake Pro subscription will be ready.
                </small>
              </p>
              <Button
                display="Checkout with Stripe"
                disabled={!this.state.policyCheck}
                color="success"
                block={true}
                size="large"
                thinking={user.tryingToCreateUserStripeCheckoutSession}
                failed={user.failedToCreateUserStripeCheckoutSession}
                successful={user.successfullyCreatedUserStripeCheckoutSession}
                onClick={e => dispatch(tryToCreateUserStripeCheckoutSession({billing_mode: this.state.pricing}))}
                />
              {
                !this.state.policyCheck && <div className="text-center small-margin-top"><small>Please review and confirm the information in the grey box before checking out.</small></div>
              }
            </div>
          </div>
        </div>
{/*
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
          <div className="example">
            <Elements>
              <CheckoutForm onSubmit={this.handleSubmit}/>
            </Elements>
          </div>
        </StripeProvider>*/}

      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(UserSettingsUpgradeToProForm);



// WEBPACK FOOTER //
// ./src/components/UserSettingsUpgradeToProForm/UserSettingsUpgradeToProForm.js